import classNames from "classnames";
import { CommandStep, GroupStep } from "~/lib/pipeline";
import JobGroup from "~/components/build/Header/pipeline/utils/jobGroup";
import { Job } from "~/components/build/Show/lib/types";

export const StatsJobCount = ({ step }: { step: CommandStep }) => {
  return (
    <span
      className={classNames(
        "text-charcoal-700 border border-slate-500 bg-white tabular-nums",
        Features.BuildPageListView ? "rounded-full px-1.5 text-xs font-medium" : "rounded-sm px-1",
      )}
    >
      {step.statistics?.jobsFinishedCount}/{step.statistics?.jobsCount}
    </span>
  );
};

// Given an array of jobs, display a count of the number of passed jobs in that group.
// This is useful for parallel, matrix and group steps.
export const JobCount = ({ jobs, step }: { jobs: Array<Job>; step: CommandStep | GroupStep }) => {
  const jobGroup = new JobGroup(step.uuid);

  for (const job of jobs) {
    jobGroup.appendJob(job);
  }

  return (
    <span
      className={classNames(
        "text-charcoal-700 border border-slate-500 bg-white tabular-nums",
        Features.BuildPageListView ? "rounded-full px-1.5 text-xs font-medium" : "rounded-sm px-1",
      )}
    >
      {jobGroup.finishedCount}/{jobGroup.total || jobGroup.jobs.length}
    </span>
  );
};
